import { Component, Inject, OnInit } from '@angular/core';
import { DwMdSectionConfigBaseComponent2, DwComponentSectionConfigPreference, DwMdItem, DwQueryHelper, DevwareMetaDataService, DwOrmDataService, DwOrmDataServiceToken, DwExpressionService, DwMessagingService, DwMetaDataService, DwMetaDataServiceToken, DwSecurityUserService, DwUiConfigRegistryService, DwUIMetaDataConfig, DwUIMetaDataConfigToken, DwMetadataFormUtilService, DwMetadataFormBuilderService, DwContextService, DwMetaDataFormService } from '@devwareapps/devware-cap';
import { NoteControlConfig } from '../../models/note-control-config.model';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { AppMetaDataService } from 'src/app/meta-data/app-meta-data.service';

@Component({
  selector: 'app-note-control-config',
  templateUrl: './note-control-config.component.html',
  styleUrls: ['./note-control-config.component.scss']
})
export class NoteControlConfigComponent
  extends  DwMdSectionConfigBaseComponent2<DwComponentSectionConfigPreference<NoteControlConfig>>  {

    constructor(
      @Inject(DwOrmDataServiceToken) private dataService: DwOrmDataService,
      dwExpressionService: DwExpressionService,
    @Inject(DwUIMetaDataConfigToken) uiMetaDataConfig: DwUIMetaDataConfig,
    @Inject(DwMetaDataServiceToken) dwMetaDataService: DwMetaDataService,
    dwFormUtilService: DwMetadataFormUtilService,
    dwFormBuilderService: DwMetadataFormBuilderService,
    dwFormService: DwMetaDataFormService,
    dwContextService : DwContextService,
    dwUiConfigRegistryService : DwUiConfigRegistryService,
    fb: FormBuilder
    ) {
      super(uiMetaDataConfig, dwMetaDataService, dwFormUtilService, dwFormBuilderService, dwFormService, dwContextService, dwUiConfigRegistryService, fb);
    }

  configFormGroup: FormGroup;
  itemMetaData: DwMdItem;
  tableMetaData: any;

  setupForm() {
    // Add config fields to the form

    this.configFormGroup = new FormGroup({
      NoteTable: new FormControl(),
      NoteKey: new FormControl(),
      NoteField: new FormControl(),
      CanDeletePermissionMeaning: new FormControl(),
      SaveOnSwitch: new FormControl()
    });
    this.setupTableList()
    this.setupAttributeList()
    this.formGroup.addControl('config', this.configFormGroup);

  }

  setConfigValue(value) {
    // temp fix
  }


  setupTableList(){
    const md = new DevwareMetaDataService();
    const qh = new DwQueryHelper();

    const query = md.DwMetaDataItem.CreateQuery()
    query.AddFilterAnd(qh.filters.NotEqual(md.DwMetaDataItem.SchemaName, 'devware'))
    const results = this.dataService.executeQuery(query);
    results.subscribe(x => {
      this.tableMetaData = x;
      //console.log(this.tableMetaData);
    });
  }

  setupAttributeList() {
    this.configFormGroup.controls['NoteTable'].valueChanges.subscribe(x => {
    console.log(this.configFormGroup.controls['NoteTable'].value)
      this.getItemMetaData(this.configFormGroup.controls['NoteTable'].value)
      .subscribe(itemMetaData => {
        this.itemMetaData = itemMetaData;
      });
    });
}
  }
